export default {
    name: "individualGroupable",
    props: [
        "individualGroupable",
        "individualGroupableProps",
    ] as const,
    events: [] as const,
} as const;
